/**
 * A global namespace for `drag` event.
 */
const dragEvent = 'drag';
export default dragEvent;
